module.exports = __webpack_public_path__ + "media/2x/SI-dc9d3696.png";